<ion-content>
  <img src="./assets/splash-port.png" class="splash" />
</ion-content>
